import { create } from "zustand";
import { persist } from "zustand/middleware";

type StatusStore = {
  isUpdating: boolean;
  showedResult: boolean;
  setIsUpdating: (flag: boolean) => void;
  setShowedResult: (flag: boolean) => void;
};

export const usePaymentStatusStore = create<StatusStore>((set) => ({
  isUpdating: false,
  showedResult: true,

  setIsUpdating: (flag) =>
    set((state) => ({
      isUpdating: flag,
    })),

  setShowedResult: (flag) =>
    set((state) => ({
      showedResult: flag,
    })),
}));

type PaymentLinkLastOpenStore = {
  lastOpen: string;
  setLastOpen: (newDate: string) => void;
};

export const usePaymentLinkLastOpenStore = create<PaymentLinkLastOpenStore>()(
  persist(
    (set) => ({
      lastOpen: new Date().toISOString().split("T")[0],
      setLastOpen: (newDate) => set({ lastOpen: newDate }),
    }),
    {
      name: "paymentlinklastopen",
    }
  )
);
